import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.showTab(0)
  }

  switch(event) {
    event.preventDefault()
    const index = this.tabTargets.indexOf(event.currentTarget)
    this.showTab(index)
  }

  showTab(index) {
    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add("font-semibold", "text-slate-900", "border-slate-900")
        tab.classList.remove("text-gray-400", "border-gray-200")
      } else {
        tab.classList.remove("font-semibold", "text-slate-900", "border-slate-900")
        tab.classList.add("text-gray-400", "border-gray-200")
      }
    })

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index)
    })
  }
}
